import { Link } from 'react-router';
import { ShieldAlert } from 'lucide-react';
import { useQueryClient } from '@tanstack/react-query';
import type { Session } from '@product-portal/shared';
import { Button } from '@/components/ui/button';
import { signOut } from '@/components/portal/user-menu';

/**
 * « Accès refusé ». For a user attached to no team it is the ONLY screen:
 * no header, no navigation, just the explanation and sign-out.
 * The screen is not drawn in the mock-ups (see CLAUDE.md, « Écarts »).
 */
export function AccessDeniedPage({ session, reason }: { session: Session; reason: 'no_team' | 'forbidden' }) {
  const queryClient = useQueryClient();
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <div aria-hidden="true" className="h-1 bg-brand-gradient" />
      <main className="mx-auto flex w-full max-w-[560px] flex-1 flex-col justify-center gap-6 px-6 py-12">
        <img src="/product-portal-logo.png" alt="Product Portal — Europa Group" className="block h-10 w-auto self-start" />
        <section className="flex flex-col gap-4 rounded-card border border-border bg-card p-8">
          <div className="flex items-center gap-3">
            <ShieldAlert aria-hidden="true" className="size-6 text-destructive" />
            <h1 className="m-0 text-[26px] font-black tracking-[-0.01em]">Accès refusé</h1>
          </div>
          {reason === 'no_team' ? (
            <p className="m-0 text-sm leading-relaxed text-foreground-secondary">
              Votre compte ({session.user.email}) n'est rattaché à aucune équipe. Le rattachement est fait par l'équipe Produit &amp; Digital ;
              vous pourrez utiliser le portail dès qu'il sera effectué.
            </p>
          ) : (
            <p className="m-0 text-sm leading-relaxed text-foreground-secondary">Votre rôle ne donne pas accès à cet espace.</p>
          )}
          <div className="flex flex-wrap gap-3">
            {reason === 'forbidden' && (
              <Button asChild variant="secondary">
                <Link to="/" className="no-underline">
                  Retour à l'accueil
                </Link>
              </Button>
            )}
            <Button variant="secondary" onClick={() => void signOut(queryClient)}>
              Se déconnecter
            </Button>
          </div>
        </section>
      </main>
    </div>
  );
}
